const app = require('app'),
    constants = require('./constants'),
    getLanguageSetting = require('./getLanguageSetting');

module.exports = function () {
    return getLanguageSetting() || constants.defaultLanguage;
};
